class SourceLooper {
	constructor(context, outNode) {
		this.outNode = outNode;
		this.context = context;
		this.sources = [];
	}

	loadSound = (url, isLoadedCallback) => {
		isLoadedCallback(0);
		let newSource = this.context.createBufferSource();

		/* --- load buffer ---  */
		var request = new XMLHttpRequest();
		//open the request
		request.open('GET', url, true);
		//webaudio paramaters
		request.responseType = 'arraybuffer';
		//Once the request has completed... do this

		request.onprogress = p => {
			isLoadedCallback(p.loaded / p.total);
		};
		request.onload = () => {
			this.context.decodeAudioData(request.response, response => {
				/* --- play the sound AFTER the buffer loaded --- */
				//set the buffer to the response we just received.

				var audioBuffer = response;
				newSource.buffer = response;

				//find max value in buffer

				var max = 0;
				for (var chi = 0; chi < audioBuffer.numberOfChannels; chi++) {
					var audioData = audioBuffer.getChannelData(chi);

					for (var i = 0; i < audioData.length; i++) {
						if (Math.abs(audioData[i]) > max) {
							max = Math.abs(audioData[i]);
						}
					}
				}

				// console.log("max",max);

				// normalize buffer
				var newMax = 0;
				for (var chi = 0; chi < audioBuffer.numberOfChannels; chi++) {
					for (var i = 0; i < audioData.length; i++) {
						audioData[i] = audioData[i] / max;
						if (Math.abs(audioData[i]) > newMax) {
							newMax = Math.abs(audioData[i]);
						}
					}
					newSource.buffer.copyToChannel(audioData, chi, 0);
				}

				// console.log("newMax",newMax);

				//start(0) should play asap.
				newSource.loop = true;
				newSource.start();

				this.sources.forEach(s => {
					s.stop();
					s.buffer = null;
				});
				newSource.connect(this.outNode);
				this.sources.push(newSource);
				isLoadedCallback(1, response);
			});
		};
		//Now that the request has been defined, actually make the request. (send it)
		request.send();
	};

	setLoopStart = startRatio => {
		let currentSource = this.sources[this.sources.length - 1];
		let startTime = startRatio * currentSource.buffer.duration;
		currentSource.loopStart = startTime;
	};

	setLoopEnd = endRatio => {
		let currentSource = this.sources[this.sources.length - 1];
		let endTime = endRatio * currentSource.buffer.duration;
		currentSource.loopEnd = endTime;
	};
}

export default SourceLooper;
